import React from "react";
import { Link } from "react-router-dom";
import { compactNumber, relativeTime } from "../../utils/relativeTime";

const truncate = (s, n = 120) => {
  if (!s) return "";
  const t = s.trim();
  return t.length <= n ? t : `${t.slice(0, n).trim()}…`;
};

const languageColor = (lang) => {
  if (!lang) return "#8b949e";
  let h = 0;
  for (let i = 0; i < lang.length; i += 1) {
    h = lang.charCodeAt(i) + ((h << 5) - h);
  }
  const hue = Math.abs(h) % 360;
  return `hsl(${hue}, 52%, 58%)`;
};

const RepoCard = ({ repo, hideOwnerContext = false, variant = "grid" }) => {
  const owner = repo.owner?.login;
  const name = repo.name;
  const to = owner && name ? `/repo/${owner}/${name}` : "#";
  const stars = compactNumber(repo.stargazers_count ?? 0);
  const forks = compactNumber(repo.forks_count ?? 0);
  const watchers = compactNumber(repo.watchers_count ?? 0);
  const branch = repo.default_branch || "main";
  const isList = variant === "list";

  return (
    <article
      className={`gf-repo-card gf-card${hideOwnerContext ? " gf-repo-card--profile" : ""}${isList ? " gf-repo-card--list" : ""}`}
    >
      <div className="gf-repo-card__head">
        {!hideOwnerContext && (
          <img
            className="gf-repo-card__owner-avatar"
            src={repo.owner?.avatar_url}
            alt=""
            width={48}
            height={48}
            loading="lazy"
          />
        )}
        <div className="gf-repo-card__head-text">
          <div className="gf-repo-card__title-row">
            <Link to={to} className="gf-repo-card__title">
              {repo.name || name}
            </Link>
            <a
              href={repo.html_url}
              target="_blank"
              rel="noopener noreferrer"
              className="gf-repo-card__ext"
              aria-label={`Open ${repo.name} on GitHub`}
            >
              ↗
            </a>
          </div>
        </div>
      </div>
      <p className="gf-repo-card__desc">{truncate(repo.description) || "No description provided."}</p>
      {isList ? (
        <div className="gf-repo-card__meta-inline">
          {repo.language ? (
            <>
              <span
                className="gf-repo-card__lang-dot"
                style={{ background: languageColor(repo.language) }}
                aria-hidden="true"
              />
              <span className="gf-repo-card__lang-name">{repo.language}</span>
            </>
          ) : (
            <span className="gf-repo-card__lang-name gf-muted">—</span>
          )}
          <span title="Stars">⭐ {stars}</span>
          <span title="Forks">🍴 {forks}</span>
          <span title="Watchers">👁 {watchers}</span>
          <span className="gf-repo-card__branch" title="Default branch">
            <code>{branch}</code>
          </span>
          <span title="Updated">📅 {relativeTime(repo.updated_at)}</span>
        </div>
      ) : (
        <>
          <div className="gf-repo-card__lang-row">
            {repo.language ? (
              <>
                <span
                  className="gf-repo-card__lang-dot"
                  style={{ background: languageColor(repo.language) }}
                  aria-hidden="true"
                />
                <span className="gf-repo-card__lang-name">{repo.language}</span>
              </>
            ) : (
              <span className="gf-repo-card__lang-name gf-muted">—</span>
            )}
          </div>
          <div className="gf-repo-card__stats">
            <span title="Stars">⭐ {stars}</span>
            <span title="Forks">🍴 {forks}</span>
            <span title="Watchers">👁 {watchers}</span>
          </div>
          <div className="gf-repo-card__footer">
            {!hideOwnerContext && (
              <span title="Owner">👤 @{repo.owner?.login}</span>
            )}
            <span className="gf-repo-card__branch" title="Default branch">
              <code>{branch}</code>
            </span>
            <span title="Updated">📅 {relativeTime(repo.updated_at)}</span>
          </div>
        </>
      )}
      <div className="gf-repo-card__actions">
        <Link to={to} className="gf-btn gf-btn--primary gf-btn--sm gf-btn--block">
          View details
        </Link>
      </div>
    </article>
  );
};

export default RepoCard;
